import { createAction, props } from '@ngrx/store';

import type { Features, InferredConsistencyCheckFromFeatures } from './consistency-checks.types';
import { FEATURE_LIST, FeatureActions, FeaturesActions } from './consistency-checks.types';

export const RESET = '[ConsistencyChecks] Reset';
export const CANCEL_LOAD_WHEN_THERE_IS_NO_ACCOUNTING_PERIOD = `[ConsistencyChecks] Cancel loading when there is no accounting period`;
export const reset = createAction(RESET);
export const cancelLoadWhenThereIsNoAccountingPeriod = createAction(CANCEL_LOAD_WHEN_THERE_IS_NO_ACCOUNTING_PERIOD);

export const ConsistencyChecksFeaturesActions: FeaturesActions = FEATURE_LIST.reduce(
  (acc, key) => ({
    ...acc,
    [key]: generateAction(key)
  }),
  {} as FeaturesActions
);

function generateAction<T extends Features = Features>(key: T): FeatureActions<T> {
  return {
    update: createAction(
      `[ConsistencyChecks] Update ${key}`,
      props<{ consistencyChecks: InferredConsistencyCheckFromFeatures<T>[] }>()
    ),
    load: createAction(`[ConsistencyChecks] Load ${key}`),
    expire: createAction(`[ConsistencyChecks] Expire ${key}`)
  };
}
